import { Stack, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import type { FunctionComponent } from "react";
import React from "react";
import { BiCopy } from "react-icons/bi";
import { SmallActionButton } from "../../contentCanvas/cell/SmallActionButton";
import { ProjectThumbHotlinks } from "../../../collection/views/ProjectActions/ProjectThumbHotlinks";
import type { DetailSectionData } from "types/content/DetailSectionData";
import { useCopyValue } from "hooks/useCopies";
import type { HotlinkAction } from "types/copy";

interface SectionFooterActionsProps {
  sectionData: DetailSectionData[];
  recordId?: string;
  isSharedRead?: boolean;
  collectionId?: string;
  onCopySection: (sectionData: DetailSectionData[]) => string;
}

export const SectionFooterActions: FunctionComponent<SectionFooterActionsProps> = ({
  sectionData,
  recordId,
  isSharedRead = false,
  collectionId,
  onCopySection,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const thumbsUpHotlinkActionsRaw = useCopyValue("copy_thumbs_up_hotlink_actions_tables");
  const thumbsDownHotlinkActionsRaw = useCopyValue("copy_thumbs_down_hotlink_actions_tables");

  const thumbsUpHotlinkActions: HotlinkAction[] = thumbsUpHotlinkActionsRaw.map((item: string) => JSON.parse(item));
  const thumbsDownHotlinkActions: HotlinkAction[] = thumbsDownHotlinkActionsRaw.map((item: string) => JSON.parse(item));

  return (
    <Stack
      spacing={isMobile ? ".5rem" : "1rem"}
      width="100%"
      height="2rem"
      px={isMobile ? ".5rem" : "1rem"}
      py={isMobile ? ".2rem" : ".5rem"}
      direction="row"
      borderTop="1px solid"
      borderColor={borderColor}
      align="center">
      <ProjectThumbHotlinks
        isDisabled={isSharedRead}
        action="up"
        recordId={recordId}
        feedbackIntent="submit_table_feedback"
        collectionId={collectionId}
        hotlinkActions={thumbsUpHotlinkActions}
      />
      <ProjectThumbHotlinks
        isDisabled={isSharedRead}
        action="down"
        recordId={recordId}
        collectionId={collectionId}
        feedbackIntent="submit_table_feedback"
        hotlinkActions={thumbsDownHotlinkActions}
      />
      <SmallActionButton
        iconSize="1rem"
        classNames="ch-copy-section"
        iconTypeName={BiCopy}
        onClick={() => navigator.clipboard.writeText(onCopySection(sectionData))}
        tooltip={"Copy Section"}
      />
    </Stack>
  );
};
